
import React from 'react';
import Pictogram from '../pictogram';

const RefundRouteReview = () => {
  return (
    <div className='route-time-details-container'>
      <div className='route-info-wrapper'>
        <div className='route-details'>
          <p className='city-origin'>MEX</p>
          <Pictogram className='navigation-arrow' id='NavigationArrow' />
          <p className='city-destination'>GDL</p>
        </div>
        <p className='from-to-desc'>Ciudad de México a Guadalajara</p>
      </div>
      <div className='flight-time-info'>
        <p className='flight-date'>Sáb., 22 feb — Mar., 27 feb</p>
        <div className='passenger-details'>
          <Pictogram className='user-icon' id='UserIcon' />
          <p className='no-of-passengers'>2 pasajeros</p>
        </div>
      </div>
    </div>
  );
};


export default RefundRouteReview;